if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

function scrollToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

scrollToTop();

window.addEventListener("load", function () {
  scrollToTop();
});

window.addEventListener("pageshow", function () {
  scrollToTop();
});

var musicUrl = $("#MS__wrapper").data("audio") || $("body").data("audio");

if (musicUrl) {
  var audioElement = $('<audio id="backgroundMusic" loop></audio>');
  audioElement.append('<source src="' + musicUrl + '" type="audio/mpeg">');
  $("body").append(audioElement);

  var audio = document.getElementById("backgroundMusic");
  var hasInteracted = false;
  var userMuted = false;

  var setMusicIcon = function (playing) {
    $(".music").toggleClass("offmusic", !playing);
  };

  var autoPlayHandler = function () {
    if (hasInteracted) return;
    hasInteracted = true;
    if (!userMuted) {
      audio.play().then(function () {
        setMusicIcon(true);
      }).catch(function (error) {
        console.log("Autoplay prevented:", error);
      });
    }
    $(document).off("click touchstart", autoPlayHandler);
  };
  $(document).on("click touchstart", autoPlayHandler);

  $(document).on("click", ".music", function (e) {
    e.preventDefault();
    e.stopPropagation();
    hasInteracted = true;
    $(document).off("click touchstart", autoPlayHandler);
    if (audio.paused) {
      userMuted = false;
      audio.play().then(function () {
        setMusicIcon(true);
      }).catch(function (error) {
        console.log("Play error:", error);
      });
    } else {
      userMuted = true;
      audio.pause();
      setMusicIcon(false);
    }
  });

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      if (!audio.paused) audio.pause();
    } else if (hasInteracted && !userMuted && audio.paused) {
      audio.play().then(function () {
        setMusicIcon(true);
      }).catch(function (error) {
        console.log("Audio resume error:", error);
      });
    }
  });
}